import { useTranslate } from '@tolgee/react';
import { Select } from 'antd';
import DecorateTitle from 'components/DecorateTitle';
import SettingItemContainer from './SettingItemContainer';
import useSystem from 'hooks/business/system/useSystem';
import languageOptions from 'components/SystemLangs/languageOptions';

export const SystemLanguage = () => {
  const { t } = useTranslate();
  const {
    systemSetting: { language },
    handleLanguageSettingChange,
  } = useSystem();

  return (
    <>
      <DecorateTitle>{t('ViewSystem.system.language')}</DecorateTitle>
      <SettingItemContainer>
        <Select
          value={language}
          options={languageOptions}
          onChange={handleLanguageSettingChange}
          className="w-[284px]"
        />
      </SettingItemContainer>
    </>
  );
};
